function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import LPEHOC from "./LPEHOC";
var withLPEHOC = function(useProps) {
    if (useProps === void 0) useProps = function(props) {
        return props;
    };
    return function(Component) {
        var WithLPEHOC = /*#__PURE__*/ forwardRef(function(props, ref) {
            var augmentedProps = useProps(props);
            return /*#__PURE__*/ _jsx(LPEHOC, _extends({}, augmentedProps, {
                children: /*#__PURE__*/ _jsx(Component, _extends({}, props, {
                    ref: ref
                }))
            }));
        });
        WithLPEHOC.displayName = "WithLPEHOC(" + (Component.displayName || Component.name) + ")";
        return WithLPEHOC;
    };
};
export default withLPEHOC;

//# sourceMappingURL=withLPEHOC.js.map